<template>
  <v-layout>
    <v-flex>
      <v-layout align-center>
        <h1 class="headline">Mandatory Charges</h1>
        <v-spacer></v-spacer>
        <div>
          <v-container pt-0>
            <list-visible-columns-and-filter
              :visible-columns="visibleColumns"
              :selectable-headers="selectableHeaders"
              v-model="search"
              @change="onVisibleColumnsChange"
            ></list-visible-columns-and-filter>
          </v-container>
        </div>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn v-on="on" fab dark color="primary" @click="createItem">
              <v-icon dark>mdi-plus</v-icon>
            </v-btn>
          </template>
          <span>Create New Mandatory Charge</span>
        </v-tooltip>
      </v-layout>

      <v-card>
        <v-data-table
          :headers="filteredHeaders"
          :items="items"
          :loading="$apollo.loading"
          v-bind="pagingOptions"
          :search="search"
          item-key="node.id"
          fixed-header
          hide-default-footer
        >
          <template v-slot:item.inUse="{ item }">
            <v-checkbox
              v-model="item.node.inUse"
              primary
              hide-details
              :disabled="true"
              class="ma-0"
            ></v-checkbox>
          </template>
          <template v-slot:item.node.dateFrom="{ item }">{{
            item.node.dateFrom | formatDate
          }}</template>
          <template v-slot:item.node.dateTo="{ item }">{{
            item.node.dateTo | formatDate
          }}</template>
          <template v-slot:item.actions="{ item }">
            <default-list-actions
              :item="item"
              :hide-view="true"
              @deleteItem="deleteItem($event)"
              @editItem="editItem($event)"
            ></default-list-actions>
          </template>
        </v-data-table>
      </v-card>

      <mandatory-charge-dialog
        v-model="selectedCharge"
        :show="chargeEditorDialog"
        @close="chargeEditorDialog = false"
        @input="onSave"
      ></mandatory-charge-dialog>
    </v-flex>
  </v-layout>
</template>

<script>
import {
  MANDATORY_CHARGE_DELETE_MUTATION,
  MANDATORY_CHARGE_CREATE_MUTATION,
  MANDATORY_CHARGE_UPDATE_MUTATION,
  ALL_MANDATORY_CHARGES_SEARCH_QUERY,
} from "../../../../constants/graphql";

import DefaultListActions from "../../shared/DefaultListActions";
import SimpleListMixin from "../../../../mixins/SimpleListMixin";
import ListVisibleColumnsAndFilter from "../../shared/ListVisibleColumnsAndFilter";
import { sortByDate } from "../../../../helpers/index";
import MandatoryChargeDialog from "./MandatoryChargeDialog";

const moment = require("moment");

export default {
  name: "RoomsList",

  components: {
    DefaultListActions,
    ListVisibleColumnsAndFilter,

    MandatoryChargeDialog,
  },
  mixins: [SimpleListMixin],
  data() {
    return {
      search: "",
      mandatoryCharges: {},
      selectedCharge: {},
      chargeEditorDialog: false,
      doSaveCharge: false,
      visibleColumns: this.$store.getters.localSettings(this.$options.name, [
        "name",
        "dateFrom",
        "dateTo",
        "perAdult",
        "actions",
      ]),
      headers: [
        {
          text: "Name",
          value: "node.name",
          name: "name",
        },
        {
          text: "Date From",
          value: "node.dateFrom",
          name: "dateFrom",
          sort: sortByDate,
        },
        {
          text: "Date To",
          value: "node.dateTo",
          name: "dateTo",
          sort: sortByDate,
        },
        {
          text: "Per Adult",
          value: "node.perAdult",
          name: "perAdult",
        },
        {
          text: "Per Child",
          value: "node.perChild",
          name: "perChild",
        },
        {
          text: "Per Infant",
          value: "node.perInfant",
          name: "perInfant",
        },
        {
          text: "Per Item",
          value: "node.perItem",
          name: "perItem",
        },
        {
          text: "Rate Type",
          value: "node.rateTypeCode",
          name: "rateTypeCode",
        },
        {
          text: "Currency",
          value: "node.currencyCode",
          name: "currencyCode",
        },
        {
          text: "In Use",
          value: "inUse",
          name: "inUse",
        },
        {
          text: "Actions",
          value: "actions",
          sortable: false,
          name: "actions",
          align: "center",
        },
      ],
    };
  },

  computed: {
    items() {
      return this.mandatoryCharges ? this.mandatoryCharges.edges : [];
    },
    filteredHeaders() {
      return this.headers.filter(
        (h) => this.visibleColumns.indexOf(h.name) > -1
      );
    },
  },

  methods: {
    createItem() {
      this.selectedCharge = {};
      this.chargeEditorDialog = true;
    },
    editItem(item) {
      this.selectedCharge = { ...item.node };
      this.chargeEditorDialog = true;
    },
    deleteItem(item) {
      this.$apollo
        .mutate({
          mutation: MANDATORY_CHARGE_DELETE_MUTATION,
          variables: {
            mandatoryChargeId: item.node.id,
          },
        })
        .then(this.removeGqlObjectHandler, this.removeGqlObjectErrorHandler);
    },
    removeGqlObjectHandler(result) {
      this.$store.dispatch("showAppSnackbar", {
        msg: "Mandatory charge removed.",
      });
      if (this.$apollo.queries.mandatoryCharges != null) {
        this.$apollo.queries.mandatoryCharges.refetch();
      }
    },
    removeGqlObjectErrorHandler(err) {
      this.$store.dispatch("showAppSnackbar", {
        msg: err.graphQLErrors[0].message,
        color: "error",
      });
    },
    showColumn(fieldName) {
      return this.visibleColumns.find((name) => name === fieldName);
    },
    onSave(payload) {
      this.chargeEditorDialog = false;
      const mutation = payload.id
        ? MANDATORY_CHARGE_UPDATE_MUTATION
        : MANDATORY_CHARGE_CREATE_MUTATION;
      this.$apollo
        .mutate({
          mutation,
          variables: payload,
          refetchQueries: [
            {
              query: ALL_MANDATORY_CHARGES_SEARCH_QUERY,
            },
          ],
        })
        .then(() => {
          this.$store.dispatch("showAppSnackbar", {
            msg: "Mandatory Charge Saved.",
          });
        })
        .catch((err) => {
          const errorMsg = err.graphQLErrors.map((e) => e.message).join(", ");
          this.$store.dispatch("showAppSnackbar", {
            msg: errorMsg,
            color: "error",
          });
        });
    },
  },

  apollo: {
    mandatoryCharges: {
      query: ALL_MANDATORY_CHARGES_SEARCH_QUERY,
      fetchPolicy: "network-only",
      result({ data, loader, networkStatus }) {},
    },
  },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/gt/admin/service-types/MandatoryChargesList.vue